import React from "react";
import styled from "styled-components/macro";
import { Arrow } from "./Arrows/Arrow";

const Title = styled.div`
  font-size: 36px;
  font-weight: 500;
`;
const RoomUnitSizeHeight = ({ isCM, title }) => {
  return (
    <div>
      <Title>{title}</Title>
      <Wrapper>
        <div style={{ width: "10px" }} />
        <InnerWrapper>
          <Unit height={70}></Unit>
          <Unit style={{ borderTop: 0, borderBottom: 0 }} height={692}></Unit>
          <Unit height={30}></Unit>
          <BottomSizeUnit></BottomSizeUnit>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              borderLeft: "1px solid grey",
              borderRight: "1px solid grey",
            }}
          >
            {" "}
            <Arrow side={"left"} />
            <ArrowText>{isCM ? "50" : "20"}.00</ArrowText>
            <Arrow side={"right"} />
          </div>
        </InnerWrapper>

        <Door>
          <BottomSizeUnitText>Open door</BottomSizeUnitText>
        </Door>
      </Wrapper>
    </div>
  );
};

export { RoomUnitSizeHeight };

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`;
const InnerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;
const ArrowText = styled.p`
  margin: 0px 8px;
  justify-content: center;
  color: #808080;
  font-size: 22px;
`;
const Unit = styled.div`
  position: relative;
  display: flex;
  font-size: 20px;
  border: 3px black solid;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: ${({ height }) => height}px;
`;
const Door = styled.div`
  display: flex;
  position: relative;
  width: 180px;
  height: 384px;
  border-radius: 2px;
  border: 2px #000 dashed;
  border-left: none;

  align-items: center;
  margin-top: 68px;
  justify-content: center;
  justify-items: center;
`;

const BottomSizeUnit = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 100px;
  border: 1px solid grey;
  margin-top: -2px;
  border-bottom: 0;
  align-items: center;
  justify-content: center;
  justify-items: center;
`;

const BottomSizeUnitText = styled.p`
  display: flex;
  position: relative;
  flex: 1;
  text-align: center;
  margin-bottom: 0;
  justify-content: center;
  color: #808080;
  font-size: 22px;
`;
